/** Tempo para o cursor atravessar do nome até o cartão sem fechá-lo. */
export const HOVER_CARD_CLOSE_DELAY_MS = 200;

export const PANEL_FLUSH_CLASS = "p-overlaypanel-flush";
